export default __webpack_public_path__ + "static/media/whiteBackground.819de97b.jpeg";